// extracted by mini-css-extract-plugin
export default {"input":"UploadedVideosSearch_input__fLHLZ"};